/**
 * 经营信息api
 */
export default {
  // 新增公司信息
  insertEnterpriseInfo: '/enterpriseInfo/insertEnterpriseInfo',
  // 查询公司信息详情
  selectEnterpriseInfoDetail: '/enterpriseInfo/selectEnterpriseInfoDetail',
  // 查询公司信息列表
  selectEnterpriseInfoList: '/enterpriseInfo/selectEnterpriseInfoList',
  // 修改公司信息
  updateEnterpriseInfo: '/enterpriseInfo/updateEnterpriseInfo',
  // 轮播图列表
  pageList: '/adCarousel/pageList',
  // 删除轮播图
  bannerDelete: '/adCarousel/delete',
  // 新增轮播图
  bannerSave: '/adCarousel/save',
  // 修改轮播图
  bannerUpdate: '/adCarousel/update',
};
